import { TipoSolucion } from './tipo-solucion.model';

export enum EstadoFormalizacion {
  CONVENIO_FIRMADO = 'CONVENIO_FIRMADO',
  CUENTA_CAPTURADA = 'CUENTA_CAPTURADA',
  CUENTA_ENVIADA_AL_BANCO = 'CUENTA_ENVIADA_AL_BANCO',
  CUENTA_ACEPTADA = 'CUENTA_ACEPTADA',
  CUENTA_RECHAZADA = 'CUENTA_RECHAZADA',
  ANEXO_I_FIRMADO_POR_SECIHTI = 'ANEXO_I_FIRMADO_POR_SECIHTI',
  CONVENIO_ACEPTADO = 'CONVENIO_ACEPTADO',
  CONVENIO_RECHAZADO = 'CONVENIO_RECHAZADO',
  CONVENIO_FIRMADO_POR_SECIHTI = 'CONVENIO_FIRMADO_POR_SECIHTI',
  CONVENIO_ASIGNADO = 'CONVENIO_ASIGNADO',
  MONTOS_ACEPTADOS_SOLICITANTE = 'MONTOS_ACEPTADOS_SOLICITANTE',
  MONTOS_RECHAZADOS_SOLICITANTE = 'MONTOS_RECHAZADOS_SOLICITANTE',
  VISA_CARGADA_SOLICITANTE = 'VISA_CARGADA_SOLICITANTE',
  VISA_ACEPTADA_SECIHTI = 'VISA_ACEPTADA_SECIHTI',
  VISA_RECHAZADA_SECIHTI = 'VISA_RECHAZADA_SECIHTI',
  OFICIO_POR_FIRMAR = 'OFICIO_POR_FIRMAR',
  SOLICITUD_FIRMADA_ELECTRONICAMENTE = 'SOLICITUD_FIRMADA_ELECTRONICAMENTE',
  CONVENIO_FIRMADO_SOLICITANTE_APOYOS = 'CONVENIO_FIRMADO_SOLICITANTE_APOYOS',
  CONVENIO_POR_FIRMA_SOLICITANTE = 'CONVENIO_POR_FIRMA_SOLICITANTE',
  CONVENIO_MODIFICATORIO_SIN_FIRMA_SOLICITANTE = 'CONVENIO_MODIFICATORIO_SIN_FIRMA_SOLICITANTE',
  CONVENIO_MODIFICATORIO_FIRMADO_POR_SOLICITANTE = 'CONVENIO_MODIFICATORIO_FIRMADO_POR_SOLICITANTE',
  CONVENIO_MODIFICATORIO_FIRMADO_POR_DIRECCION_ADJUNTA = 'CONVENIO_MODIFICATORIO_FIRMADO_POR_DIRECCION_ADJUNTA',
  OFICIO_FIRMADO = 'OFICIO_FIRMADO',
  SEGUIMIENTO_FORMALIZACION_SIN_REVISION_ANEXO_1_SOLICITANTE = 'SEGUIMIENTO_FORMALIZACION_SIN_REVISION_ANEXO_1_SOLICITANTE',
  CANCELADA = 'CANCELADA',
  FINALIZADA = 'FINALIZADA',
  ASIGNADA = 'ASIGNADA',
}

const estadosFormalizacionPorTipoSolucion: Record<TipoSolucion, EstadoFormalizacion[]> = {
  AYUDANTES: [],
  INGRESO_PERMANENCIA_PROMOCION: [],
  EMERITOS: [],
  BECAS_NACIONALES: [
    EstadoFormalizacion.SOLICITUD_FIRMADA_ELECTRONICAMENTE,
    EstadoFormalizacion.ANEXO_I_FIRMADO_POR_SECIHTI,
    EstadoFormalizacion.CONVENIO_POR_FIRMA_SOLICITANTE,
    EstadoFormalizacion.CONVENIO_FIRMADO_POR_SECIHTI,
  ],
  BECAS_EXTRANJERAS: [],
  POSGRADO_NACIONAL: [],
  POSDOCTORADO: [],
  CUENTAS_BANCARIAS: [],
  ACREDITACIONES: [],
  ACREDITACIONES_SIN_INST: [],
  INSTITUCIONES: [],
  REGISTRO_MATRICULA_SNP: [],
  MOVIMIENTOS_SITUACION: [],
  ACREDITACIONES_PROGRAMAS: [],
  REGISTRO_MATRICULA_LIC: [],
  APOYOS_COMPLEMENTARIOS_BN: [],
  APOYOS_COMPLEMENTARIOS_EXT: [],
  ACREDITACION_MASIVA: [],
  EXCEPCIONES_SNII: [],
  EXCEPCIONES_EMERITOS_65: [],
  EXPEDIENTE_PERSONA: [],
  CUENTAS_BANCARIAS_SNII_INV: [],
  CUENTAS_BANCARIAS_SNII_AYU: [],
  FORMATO_1_POSGRADO_NACIONAL: [],
  DIASPORA: [],
  ACTIVIDAD_RETRIBUCION_SOCIAL: [],
};

export default function obtenerEstadosFormalizacionPorTipoSolucion(tipo: TipoSolucion.BECAS_NACIONALES): EstadoFormalizacion[] {
  return estadosFormalizacionPorTipoSolucion[tipo];
}
